export const AppRoutes = Object.freeze({
  HOME: "/",
  PROPERTIES: "/propiedades",
  RENT: "/arrendar",
  BUY: "/comprar",
  REQUIREMENTS: "/requisitos",
  SERVICES: "/servicios",
  CONSIGN: "/consignar",
  ABOUT_US: "/nosotros",
  CONTACT_US: "/contactenos",
  FORGOT_PASSWORD: "/recuperar-contrasena",
  VALIDATE_LESSEE: "/validacion",
  UPDATE_BASIC_DATA: "/actualiza-tu-info",
  LOGIN: "/login",
  PROPERTY_DETAIL: "/propiedad/:code", // Path with a parameter
  LESSEE_HOME: "/arrendatario",
  OWNER_HOME: "/propietario",
  RECOVER_PASSWORD: "/restaurar_contrasena/:recovery_token",
});
